export const selectFeatureFlags = state => state.featureFlags;
